 
class DeleteAccountingEntry {

  constructor() {
    this.searchString = undefined;
    this.searchInt = undefined; 
    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined
    }

  }
}
export default new DeleteAccountingEntry();
 